module.exports = __webpack_public_path__ + "media/images/views/dashboard/star-1-5d00537ebbdf18ba1fff0655b3a7f2cf.svg";